<script>
import ProposalRenderer from '@/components/common/ProposalRenderer'
import moment from 'moment'
import { mapGetters, mapState } from 'vuex'
import { formApi } from '../../api'

export default {
  name: 'HoneyFormDetail',

  props: {
    honeyFormProp: Object
  },

  data() {
    return {
      editFormKey: false,
      editDescription: false,
      editCandidateUsers: false,
      editAssignee: false,
      editCandidateGroups: false,
      editAdditionalDelegationList: false,
      editEmailTemplate: false,
      editEmailConditions: false,
      showProposal: true,
      showEmailSettings: true,
      honeyFormUpdating: false,
      camundaUsersUpdating: false,
      emailTemplatesUpdating: false,
      camundaGroupsUpdating: false,
      formKey: '',
      description: '',
      assignee: '',
      emailTemplate: '',
      candidateUsers: [],
      candidateGroups: [],
      additionalDelegationList: [],
      defaultEmailCondition: {
        blockEmail: false,
        attachment: false,
        requesterInCC: false,
        addHeaderData: false,
        candidateUsersInCC: false
      },
      onCreateCondition: {
        blockEmail: false,
        attachment: false,
        requesterInCC: false,
        addHeaderData: false,
        candidateUsersInCC: false
      },
      onAssignCondition: {
        blockEmail: false,
        attachment: false,
        requesterInCC: false,
        addHeaderData: false,
        candidateUsersInCC: false
      },
      onClosureCondition: {
        blockEmail: false,
        attachment: false,
        requesterInCC: false,
        addHeaderData: false,
        candidateUsersInCC: false
      },
      onTimeoutCondition: {
        blockEmail: false,
        attachment: false,
        requesterInCC: false,
        addHeaderData: false,
        candidateUsersInCC: false
      },
      onDeleteCondition: {
        blockEmail: false,
        attachment: false,
        requesterInCC: false,
        addHeaderData: false,
        candidateUsersInCC: false
      },
      honeyForm: null
    }
  },

  watch: {
    honeyFormProp() {
      this.honeyForm = this.honeyFormProp
    },
    honeyForm() {
      this.getAssociations()
      this.formKey = this.honeyForm.formKey
      this.description = this.honeyForm.description
      this.assignee = this.honeyForm.assignee
      this.emailTemplate = this.honeyForm.emailTemplate
      this.candidateUsers = this.honeyForm.candidateUsers || []
      this.candidateGroups = this.honeyForm.candidateGroups || []
      this.onCreateCondition =
        this.honeyForm.onCreateCondition || this.onCreateCondition
      this.onAssignCondition =
        this.honeyForm.onAssignCondition || this.onAssignCondition
      this.onClosureCondition =
        this.honeyForm.onClosureCondition || this.onClosureCondition
      this.onTimeoutCondition =
        this.honeyForm.onTimeoutCondition || this.onTimeoutCondition
      this.onDeleteCondition =
        this.honeyForm.onDeleteCondition || this.onDeleteCondition
    }
  },

  computed: {
    ...mapState({
      honeyUsers: state => state.honeyUsers.honeyUsers,
      emailTemplates: state => state.emailTemplates.emailTemplates,
      camundaUsers: state => state.camunda.camundaUsers,
      camundaGroups: state => state.camunda.camundaGroups
    }),
    camundaUserIds() {
      return this.camundaUsers.map(a => a.id)
    },
    camundaGroupIds() {
      return this.camundaGroups.map(a => a.id)
    },
    ...mapGetters({
      can: 'can'
    })
  },

  // mounted() {
  //   this.onCreateCondition =
  //     this.honeyForm.onCreateCondition || this.onCreateCondition
  //   this.onAssignCondition =
  //     this.honeyForm.onAssignCondition || this.onAssignCondition
  //   this.onClosureCondition =
  //     this.honeyForm.onClosureCondition || this.onClosureCondition
  //   this.onTimeoutCondition =
  //     this.honeyForm.onTimeoutCondition || this.onTimeoutCondition
  //   this.onDeleteCondition =
  //     this.honeyForm.onDeleteCondition || this.onDeleteCondition
  // },

  async created() {
    if (this.honeyForm || this.honeyFormProp) {
      if (!this.honeyForm) this.honeyForm = this.honeyFormProp
      this.getAssociations()
    } else {
      const { data } = await formApi.fetchForm(this.$route.params.hexId)
      if (data) {
        this.honeyForm = data
      }
    }
    this.getCamundaUsers()
    this.getCamundaGroups()
    this.getEmailTemplates()
    this.getAssociations()
  },

  methods: {
    getAssociations() {
      this.getEmailTemplate()
    },
    async getEmailTemplate() {
      this.honeyFormUpdating = true
      try {
        this.emailTemplate = await this.$store.dispatch(
          'fetchEmailTemplateForForm',
          this.honeyForm.hexId
        )
      } catch (e) {
        if (e.response.data.status === 404) {
          await this.$store.dispatch('directNotification', {
            type: 'warning',
            message: 'No Email Template assigned',
            description:
              "No Email Template assigned to the Form, The 'default' Email Template (if present) will be used.",
            timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
          })
        } else {
          await this.$store.dispatch('directNotification', {
            type: 'error',
            message: 'Unable to fetch Email Template for the Form',
            description: e.response
              ? e.response.data.message
              : 'Unable to fetch Email Template for the Form',
            timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
          })
        }
      }
      this.honeyFormUpdating = false
    },
    async setFormKey() {
      this.honeyFormUpdating = true
      this.editFormKey = false
      try {
        await this.$store.dispatch('updateHoneyForm', {
          body: { formKey: this.formKey },
          hexId: this.honeyForm.hexId
        })
        await this.$store.dispatch('directNotification', {
          message: 'Form renamed Successfully',
          description: 'Form renamed Successfully',
          type: 'success',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Form rename Failed',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
        this.resetName()
      }
      this.honeyFormUpdating = false
    },

    resetEmailTemplate() {
      this.editEmailTemplate = false
      this.emailTemplate = this.honeyForm.emailTemplate
    },

    async setEmailTemplate() {
      this.honeyFormUpdating = true
      this.editEmailTemplate = false
      try {
        await this.$store.dispatch('updateHoneyForm', {
          body: {
            emailTemplate: `/api/v1/emailTemplate/${this.emailTemplate}`
          },
          hexId: this.honeyForm.hexId
        })
        await this.$store.dispatch('directNotification', {
          message: 'Email Template updated Successfully',
          description: 'Email Template updated Successfully',
          type: 'success',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Email Template update Failed',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
        this.resetEmailTemplate()
      }
      this.honeyFormUpdating = false
    },

    resetFormKey() {
      this.editFormKey = false
      this.formKey = this.honeyForm.formKey
    },

    async setAssignee() {
      this.honeyFormUpdating = true
      this.editAssignee = false
      try {
        await this.$store.dispatch('updateHoneyForm', {
          body: { assignee: this.assignee },
          hexId: this.honeyForm.hexId
        })
        await this.$store.dispatch('directNotification', {
          message: 'Form Assignee details updated Successfully',
          description: 'Form Assignee details updated Successfully',
          type: 'success',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Form Assignee update Failed',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
        this.resetAssignee()
      }
      this.honeyFormUpdating = false
    },

    resetAssignee() {
      this.editAssignee = false
      this.assignee = this.honeyForm.assignee
    },

    async getCamundaUsers() {
      this.camundaUsersUpdating = true
      try {
        await this.$store.dispatch('fetchCamundaUsers')
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Candidate User(s)',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.camundaUsersUpdating = false
    },

    async getEmailTemplates() {
      this.emailTemplatesUpdating = true
      try {
        await this.$store.dispatch('fetchEmailTemplates')
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Email Template(s)',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.emailTemplatesUpdating = false
    },

    removeCandidateUserItem(item) {
      this.candidateUsers.splice(this.candidateUsers.indexOf(item), 1)
      this.candidateUsers = [...this.candidateUsers]
    },

    async setCandidateUsers() {
      this.honeyFormUpdating = true
      this.editCandidateUsers = false
      try {
        await this.$store.dispatch('updateHoneyForm', {
          body: { candidateUsers: this.candidateUsers },
          hexId: this.honeyForm.hexId
        })
        await this.$store.dispatch('directNotification', {
          message: 'Form candidate users updated Successfully',
          description: 'Form candidate users updated Successfully',
          type: 'success',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Form candidate users update Failed',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
        this.resetCandidateUsers()
      }
      this.honeyFormUpdating = false
    },

    resetCandidateUsers() {
      this.editCandidateUsers = false
      this.candidateUsers = this.honeyForm.candidateUsers || []
    },

    async getCamundaGroups() {
      this.camundaGroupsUpdating = true
      try {
        await this.$store.dispatch('fetchCamundaGroups')
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Candidate Group(s)',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.camundaGroupsUpdating = false
    },

    removeCandidateGroupItem(item) {
      this.candidateGroups.splice(this.candidateGroups.indexOf(item), 1)
      this.candidateGroups = [...this.candidateGroups]
    },

    removeAdditionalDelegationList(item) {
      this.additionalDelegationList.splice(
        this.additionalDelegationList.indexOf(item),
        1
      )
      this.additionalDelegationList = [...this.editAdditionalDelegationList]
    },

    async setCandidateGroups() {
      this.honeyFormUpdating = true
      this.editCandidateGroups = false
      try {
        await this.$store.dispatch('updateHoneyForm', {
          body: { candidateGroups: this.candidateGroups },
          hexId: this.honeyForm.hexId
        })
        await this.$store.dispatch('directNotification', {
          message: 'Form candidate groups updated Successfully',
          description: 'Form candidate groups updated Successfully',
          type: 'success',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Form candidate groups update Failed',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
        this.resetCandidateGroups()
      }
      this.honeyFormUpdating = false
    },

    async setAdditionalDelegationList() {
      this.honeyFormUpdating = true
      this.editAdditionalDelegationList = false
      try {
        await this.$store.dispatch('updateHoneyForm', {
          body: { additionalDelegationList: this.additionalDelegationList },
          hexId: this.honeyForm.hexId
        })
        await this.$store.dispatch('directNotification', {
          message: 'Form additional delegation groups updated Successfully',
          description: 'Form candidate groups updated Successfully',
          type: 'success',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Form additional delegation groups update Failed',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
        this.resetCandidateGroups()
      }
      this.honeyFormUpdating = false
    },

    resetCandidateGroups() {
      this.editCandidateGroups = false
      this.candidateGroups = this.honeyForm.candidateGroups || []
    },

    resetAdditionalDelegationList() {
      this.editAdditionalDelegationList = false
      this.additionalDelegationList =
        this.honeyForm.additionalDelegationList || []
    },

    async setDescription() {
      this.honeyFormUpdating = true
      this.editDescription = false
      try {
        await this.$store.dispatch('updateHoneyForm', {
          body: { description: this.description },
          hexId: this.honeyForm.hexId
        })
        await this.$store.dispatch('directNotification', {
          message: 'Form description updated Successfully',
          description: 'Form description updated Successfully',
          type: 'success',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Form description update Failed',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
        this.resetDescription()
      }
      this.honeyFormUpdating = false
    },

    resetDescription() {
      this.editDescription = false
      this.description = this.honeyForm.description
    },

    editForm() {
      this.$router
        .push({
          name: 'honey-form-designer-detail',
          params: { honeyForm: this.honeyForm, hexId: this.honeyForm.hexId }
        })
        .catch()
    },

    async setEmailSettings() {
      this.honeyFormUpdating = true
      this.editEmailConditions = false
      try {
        await this.$store.dispatch('updateHoneyForm', {
          body: {
            onCreateCondition: this.onCreateCondition,
            onAssignCondition: this.onAssignCondition,
            onClosureCondition: this.onClosureCondition,
            onTimeoutCondition: this.onTimeoutCondition,
            onDeleteCondition: this.onDeleteCondition
          },
          hexId: this.honeyForm.hexId
        })
        await this.$store.dispatch('directNotification', {
          message: 'Email Settings updated Successfully',
          description:
            'Email notification settings for Form updated Successfully',
          type: 'success',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Email Settings update Failed',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
        this.resetEmailSettings()
      }
      this.honeyFormUpdating = false
    },
    resetEmailSettings() {
      this.editEmailConditions = false
      this.onCreateCondition =
        this.honeyForm.onCreateCondition || this.defaultEmailCondition
      this.onAssignCondition =
        this.honeyForm.onAssignCondition || this.defaultEmailCondition
      this.onClosureCondition =
        this.honeyForm.onClosureCondition || this.defaultEmailCondition
      this.onTimeoutCondition =
        this.honeyForm.onTimeoutCondition || this.defaultEmailCondition
      this.onDeleteCondition =
        this.honeyForm.onDeleteCondition || this.defaultEmailCondition
    }
  },

  components: {
    ProposalRenderer
  }
}
</script>
<template>
  <v-card class="beez-card">
    <v-toolbar card class="elevation-2" dense>
      <v-toolbar-title class="body-2 beez-bold "
        >{{ honeyForm.formKey }}
      </v-toolbar-title>
    </v-toolbar>
    <v-progress-linear
      :active="honeyFormUpdating"
      class="ma-0"
      color="accent"
      height="5"
      indeterminate
    />
    <div class="pa-3">
      <v-text-field
        v-model="formKey"
        :outline="$vuetify.dark"
        :readonly="!editFormKey"
        color="secondary"
        label="Form Key(Unique Key)"
      >
        <template slot="append">
          <template v-if="editFormKey">
            <v-icon @click="resetFormKey">clear</v-icon>
            <v-icon @click="setFormKey">save</v-icon>
          </template>
          <template v-else>
            <v-icon v-if="can('FORMS_KEY_EDIT')" @click="editFormKey = true"
              >edit
            </v-icon>
          </template>
        </template>
      </v-text-field>
      <v-textarea
        v-model="description"
        :outline="$vuetify.dark"
        :readonly="!editDescription"
        :row="1"
        color="secondary"
        label="Description"
        no-resize
      >
        <template slot="append">
          <template v-if="editDescription">
            <v-icon @click="resetDescription">clear</v-icon>
            <v-icon @click="setDescription">save</v-icon>
          </template>
          <template v-else>
            <v-icon
              v-if="can('FORMS_DESCRIPTION_EDIT')"
              @click="editDescription = true"
              >edit
            </v-icon>
          </template>
        </template>
      </v-textarea>
      <v-autocomplete
        v-model="assignee"
        :items="camundaUserIds"
        :loading="camundaUsersUpdating"
        :menu-props="{ value: editAssignee }"
        :outline="$vuetify.dark"
        :readonly="!editAssignee"
        chips
        color="secondary"
        hide-selected
        label="Assignee"
      >
        <template slot="selection" slot-scope="data">
          <v-chip
            :key="JSON.stringify(data.item)"
            :disabled="data.disabled"
            :selected="data.selected"
            class="chip--select-multi"
            close
            @input="assignee = ''"
          >
            <v-avatar
              class="secondary"
              v-text="data.item.slice(0, 1).toUpperCase()"
            />
            {{ data.item }}
          </v-chip>
        </template>
        <template slot="append">
          <template v-if="editAssignee">
            <v-icon @click="resetAssignee">clear</v-icon>
            <v-icon @click="setAssignee">save</v-icon>
          </template>
          <template v-else>
            <v-icon
              v-if="can('FORMS_ASSIGNEE_EDIT')"
              @click="editAssignee = true"
              >edit
            </v-icon>
          </template>
        </template>
      </v-autocomplete>
      <v-autocomplete
        v-model="candidateUsers"
        :items="camundaUserIds"
        :loading="camundaUsersUpdating"
        :menu-props="{ value: editCandidateUsers }"
        :outline="$vuetify.dark"
        :readonly="!editCandidateUsers"
        chips
        color="secondary"
        label="Candidate users"
        multiple
      >
        <template slot="selection" slot-scope="data">
          <v-chip
            :key="JSON.stringify(data.item)"
            :disabled="data.disabled"
            :selected="data.selected"
            class="v-chip--select-multi"
            close
            @input="removeCandidateUserItem(data.item)"
          >
            <v-avatar
              class="secondary"
              v-text="data.item.slice(0, 1).toUpperCase()"
            />
            {{ data.item }}
          </v-chip>
        </template>
        <template slot="append">
          <template v-if="editCandidateUsers">
            <v-icon @click.stop="resetCandidateUsers">clear</v-icon>
            <v-icon @click.stop="setCandidateUsers">save</v-icon>
          </template>
          <template v-else>
            <v-icon
              v-if="can('FORMS_CANDIDATE_USERS_EDIT')"
              @click.stop="editCandidateUsers = true"
              >edit
            </v-icon>
          </template>
        </template>
      </v-autocomplete>
      <v-autocomplete
        v-model="emailTemplate"
        :items="emailTemplates"
        :loading="emailTemplatesUpdating"
        :menu-props="{ value: editEmailTemplate }"
        :outline="$vuetify.dark"
        :readonly="!editEmailTemplate"
        chips
        color="secondary"
        hide-selected
        item-text="name"
        item-value="hexId"
        label="Email Template"
      >
        <template slot="selection" slot-scope="data">
          <v-chip
            :key="JSON.stringify(data.item)"
            :disabled="data.disabled"
            :selected="data.selected"
            class="chip--select-multi"
            close
            @input="emailTemplate = ''"
          >
            <v-avatar
              class="secondary"
              v-text="data.item.name.slice(0, 1).toUpperCase()"
            />
            {{ data.item.name }}
          </v-chip>
        </template>
        <template slot="append">
          <template v-if="editEmailTemplate">
            <v-icon @click="resetEmailTemplate">clear</v-icon>
            <v-icon @click="setEmailTemplate">save</v-icon>
          </template>
          <template v-else>
            <v-icon
              v-if="can('FORMS_EMAIL_TEMPLATE_EDIT')"
              @click="editEmailTemplate = true"
              >edit
            </v-icon>
          </template>
        </template>
      </v-autocomplete>
      <v-autocomplete
        v-model="candidateGroups"
        :items="camundaGroupIds"
        :loading="camundaGroupsUpdating"
        :menu-props="{ value: editCandidateGroups }"
        :outline="$vuetify.dark"
        :readonly="!editCandidateGroups"
        chips
        color="secondary"
        label="Candidate Groups"
        multiple
      >
        <template slot="selection" slot-scope="data">
          <v-chip
            :key="JSON.stringify(data.item)"
            :disabled="data.disabled"
            :selected="data.selected"
            class="v-chip--select-multi"
            close
            @input="removeCandidateGroupItem(data.item)"
          >
            <v-avatar
              class="secondary"
              v-text="data.item.slice(0, 1).toUpperCase()"
            />
            {{ data.item }}
          </v-chip>
        </template>
        <template slot="append">
          <template v-if="editCandidateGroups">
            <v-icon @click.stop="resetCandidateGroups">clear</v-icon>
            <v-icon @click.stop="setCandidateGroups">save</v-icon>
          </template>
          <template v-else>
            <v-icon
              v-if="can('FORMS_CANDIDATE_GROUP_EDIT')"
              @click.stop="editCandidateGroups = true"
              >edit
            </v-icon>
          </template>
        </template>
      </v-autocomplete>
      <v-autocomplete
        v-model="additionalDelegationList"
        :items="camundaGroupIds"
        :loading="camundaGroupsUpdating"
        :menu-props="{ value: editAdditionalDelegationList }"
        :outline="$vuetify.dark"
        :readonly="!editAdditionalDelegationList"
        chips
        color="secondary"
        label="Additional Delegation Groups"
        multiple
      >
        <template slot="selection" slot-scope="data">
          <v-chip
            :key="JSON.stringify(data.item)"
            :disabled="data.disabled"
            :selected="data.selected"
            class="v-chip--select-multi"
            close
            @input="removeAdditionalDelegationList(data.item)"
          >
            <v-avatar
              class="secondary"
              v-text="data.item.slice(0, 1).toUpperCase()"
            />
            {{ data.item }}
          </v-chip>
        </template>
        <template slot="append">
          <template v-if="editAdditionalDelegationList">
            <v-icon @click.stop="resetAdditionalDelegationList">clear</v-icon>
            <v-icon @click.stop="setAdditionalDelegationList">save</v-icon>
          </template>
          <template v-else>
            <v-icon
              v-if="can('FORMS_CANDIDATE_GROUP_EDIT')"
              @click.stop="editAdditionalDelegationList = true"
              >edit
            </v-icon>
          </template>
        </template>
      </v-autocomplete>
      <div v-if="can('FORM_INPUT_PROPOSAL')" class="pt-4">
        <v-card>
          <v-toolbar card class="elevation-2" dense>
            <v-toolbar-title class="body-2 beez-bold "
              >Form Inputs
            </v-toolbar-title>
            <v-spacer />
            <transition mode="out-in" name="fade">
              <v-btn flat icon @click="editForm">
                <v-icon>edit</v-icon>
              </v-btn>
            </transition>
            <transition mode="out-in" name="fade">
              <v-btn flat icon @click="showProposal = !showProposal">
                <v-icon
                  >{{
                    showProposal ? 'keyboard_arrow_up' : 'keyboard_arrow_down'
                  }}
                </v-icon>
              </v-btn>
            </transition>
          </v-toolbar>
          <transition mode="out-in" name="bounce">
            <v-card-text v-if="showProposal" :key="honeyForm.hexId">
              <proposal-renderer
                v-if="honeyForm.proposals"
                :cancel="true"
                :proposals="honeyForm.proposals"
                :readonly="true"
              >
              </proposal-renderer>
              <template v-else
                >No Form Inputs found
              </template>
            </v-card-text>
          </transition>
        </v-card>
      </div>
      <div v-if="can('FORM_EMAIL_CONDITIONS')" class="pt-4">
        <v-card>
          <v-toolbar card class="elevation-2" dense>
            <v-toolbar-title class="body-2 beez-bold "
              >Email Notifications Settings
            </v-toolbar-title>
            <v-spacer />
            <template v-if="editEmailConditions">
              <v-btn flat icon @click="resetEmailSettings">
                <v-icon>clear</v-icon>
              </v-btn>
              <v-btn flat icon @click="setEmailSettings">
                <v-icon>save</v-icon>
              </v-btn>
            </template>
            <template v-else>
              <v-btn
                v-if="can('FORM_EMAIL_CONDITIONS_EDIT')"
                flat
                icon
                @click="editEmailConditions = true"
              >
                <v-icon>edit</v-icon>
              </v-btn>
            </template>
            <v-btn flat icon @click="showEmailSettings = !showEmailSettings">
              <v-icon
                >{{
                  showEmailSettings
                    ? 'keyboard_arrow_up'
                    : 'keyboard_arrow_down'
                }}
              </v-icon>
            </v-btn>
          </v-toolbar>
          <transition mode="out-in" name="bounce">
            <v-card-text v-if="showEmailSettings" :key="honeyForm.hexId">
              <v-card :disabled="!editEmailConditions">
                <v-card-title class="beez-bold body-1">
                  Task Create Event
                </v-card-title>
                <v-card-text>
                  <v-layout align-start justify-center row wrap xs12>
                    <v-flex lg6 md6 xs12>
                      <v-switch
                        v-model="onCreateCondition.blockEmail"
                        :disabled="!editEmailConditions"
                        color="primary"
                        hide-details
                        label="Block Email "
                      ></v-switch>
                    </v-flex>
                    <v-flex lg6 md6 xs12>
                      <v-switch
                        v-model="onCreateCondition.attachment"
                        :disabled="!editEmailConditions"
                        color="primary"
                        hide-details
                        label="Task attachment"
                      ></v-switch>
                    </v-flex>
                    <v-flex lg6 md6 xs12>
                      <v-switch
                        v-model="onCreateCondition.requesterInCC"
                        :disabled="!editEmailConditions"
                        color="primary"
                        hide-details
                        label="Keep Requester in CC"
                      ></v-switch>
                    </v-flex>
                    <v-flex lg6 md6 xs12>
                      <v-switch
                        v-model="onCreateCondition.addHeaderData"
                        :disabled="!editEmailConditions"
                        color="primary"
                        hide-details
                        label="Add Task Header Data"
                      ></v-switch>
                    </v-flex>
                    <v-flex lg6 md6 xs12>
                      <v-switch
                        v-model="onCreateCondition.candidateUsersInCC"
                        :disabled="!editEmailConditions"
                        color="primary"
                        hide-details
                        label="Keep Candidate Users in CC"
                      ></v-switch>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
              <v-card :disabled="!editEmailConditions" class="my-2">
                <v-card-title class="beez-bold body-1">
                  Task Assignment Event
                </v-card-title>
                <v-card-text>
                  <v-layout align-start justify-center row wrap xs12>
                    <v-flex lg6 md6 xs12>
                      <v-switch
                        v-model="onAssignCondition.blockEmail"
                        :disabled="!editEmailConditions"
                        color="primary"
                        hide-details
                        label="Block Email "
                      ></v-switch>
                    </v-flex>
                    <v-flex lg6 md6 xs12>
                      <v-switch
                        v-model="onAssignCondition.attachment"
                        :disabled="!editEmailConditions"
                        color="primary"
                        hide-details
                        label="Task attachment"
                      ></v-switch>
                    </v-flex>
                    <v-flex lg6 md6 xs12>
                      <v-switch
                        v-model="onAssignCondition.requesterInCC"
                        :disabled="!editEmailConditions"
                        color="primary"
                        hide-details
                        label="Keep Requester in CC"
                      ></v-switch>
                    </v-flex>
                    <v-flex lg6 md6 xs12>
                      <v-switch
                        v-model="onAssignCondition.addHeaderData"
                        :disabled="!editEmailConditions"
                        color="primary"
                        hide-details
                        label="Add Task Header Data"
                      ></v-switch>
                    </v-flex>
                    <v-flex lg6 md6 xs12>
                      <v-switch
                        v-model="onAssignCondition.candidateUsersInCC"
                        :disabled="!editEmailConditions"
                        color="primary"
                        hide-details
                        label="Keep Candidate Users in CC"
                      ></v-switch>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
              <v-card :disabled="!editEmailConditions" class="my-2">
                <v-card-title class="beez-bold body-1">
                  Task TimeOut Event
                </v-card-title>
                <v-card-text>
                  <v-layout align-start justify-center row wrap xs12>
                    <v-flex lg6 md6 xs12>
                      <v-switch
                        v-model="onTimeoutCondition.blockEmail"
                        :disabled="!editEmailConditions"
                        color="primary"
                        hide-details
                        label="Block Email "
                      ></v-switch>
                    </v-flex>
                    <v-flex lg6 md6 xs12>
                      <v-switch
                        v-model="onTimeoutCondition.attachment"
                        :disabled="!editEmailConditions"
                        color="primary"
                        hide-details
                        label="Task attachment"
                      ></v-switch>
                    </v-flex>
                    <v-flex lg6 md6 xs12>
                      <v-switch
                        v-model="onTimeoutCondition.requesterInCC"
                        :disabled="!editEmailConditions"
                        color="primary"
                        hide-details
                        label="Keep Requester in CC"
                      ></v-switch>
                    </v-flex>
                    <v-flex lg6 md6 xs12>
                      <v-switch
                        v-model="onTimeoutCondition.addHeaderData"
                        :disabled="!editEmailConditions"
                        color="primary"
                        hide-details
                        label="Add Task Header Data"
                      ></v-switch>
                    </v-flex>
                    <v-flex lg6 md6 xs12>
                      <v-switch
                        v-model="onTimeoutCondition.candidateUsersInCC"
                        :disabled="!editEmailConditions"
                        color="primary"
                        hide-details
                        label="Keep Candidate Users in CC"
                      ></v-switch>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
              <v-card :disabled="!editEmailConditions" class="my-2">
                <v-card-title class="beez-bold body-1">
                  Task Closure Event
                </v-card-title>
                <v-card-text>
                  <v-layout align-start justify-center row wrap xs12>
                    <v-flex lg6 md6 xs12>
                      <v-switch
                        v-model="onClosureCondition.blockEmail"
                        :disabled="!editEmailConditions"
                        color="primary"
                        hide-details
                        label="Block Email "
                      ></v-switch>
                    </v-flex>
                    <v-flex lg6 md6 xs12>
                      <v-switch
                        v-model="onClosureCondition.attachment"
                        :disabled="!editEmailConditions"
                        color="primary"
                        hide-details
                        label="Task attachment"
                      ></v-switch>
                    </v-flex>
                    <v-flex lg6 md6 xs12>
                      <v-switch
                        v-model="onClosureCondition.requesterInCC"
                        :disabled="!editEmailConditions"
                        color="primary"
                        hide-details
                        label="Keep Requester in CC"
                      ></v-switch>
                    </v-flex>
                    <v-flex lg6 md6 xs12>
                      <v-switch
                        v-model="onClosureCondition.addHeaderData"
                        :disabled="!editEmailConditions"
                        color="primary"
                        hide-details
                        label="Add Task Header Data"
                      ></v-switch>
                    </v-flex>
                    <v-flex lg6 md6 xs12>
                      <v-switch
                        v-model="onClosureCondition.candidateUsersInCC"
                        :disabled="!editEmailConditions"
                        color="primary"
                        hide-details
                        label="Keep Candidate Users in CC"
                      ></v-switch>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
              <v-card :disabled="!editEmailConditions" class="my-2">
                <v-card-title class="beez-bold body-1">
                  Task Delete Event
                </v-card-title>
                <v-card-text>
                  <v-layout align-start justify-center row wrap xs12>
                    <v-flex lg6 md6 xs12>
                      <v-switch
                        v-model="onDeleteCondition.blockEmail"
                        :disabled="!editEmailConditions"
                        color="primary"
                        hide-details
                        label="Block Email "
                      ></v-switch>
                    </v-flex>
                    <v-flex lg6 md6 xs12>
                      <v-switch
                        v-model="onDeleteCondition.attachment"
                        :disabled="!editEmailConditions"
                        color="primary"
                        hide-details
                        label="Task attachment"
                      ></v-switch>
                    </v-flex>
                    <v-flex lg6 md6 xs12>
                      <v-switch
                        v-model="onDeleteCondition.requesterInCC"
                        :disabled="!editEmailConditions"
                        color="primary"
                        hide-details
                        label="Keep Requester in CC"
                      ></v-switch>
                    </v-flex>
                    <v-flex lg6 md6 xs12>
                      <v-switch
                        v-model="onDeleteCondition.addHeaderData"
                        :disabled="!editEmailConditions"
                        color="primary"
                        hide-details
                        label="Add Task Header Data"
                      ></v-switch>
                    </v-flex>
                    <v-flex lg6 md6 xs12>
                      <v-switch
                        v-model="onDeleteCondition.candidateUsersInCC"
                        :disabled="!editEmailConditions"
                        color="primary"
                        hide-details
                        label="Keep Candidate Users in CC"
                      ></v-switch>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-card-text>
          </transition>
        </v-card>
      </div>
    </div>
  </v-card>
</template>
